module.exports = __webpack_public_path__ + "img/bookshelf-var-01.de25986e.png";